<template>
  <div class="container">
    <img class="mobile-show hand-drawn" src="../assets/girl_at_piano.jpg"/>
    <div>
      <p>
        Lenore strives to encourage her students' love of music by making piano accessible and fun.
        <br/>
        <br/>
        She brings her background in piano, music theory and education to each individualized lesson.
      </p>
      <p class="cta">Questions? Or to schedule a meeting or lesson, <span style="font-weight: bold">call or text at</span></p>

      <div id="number-container">
        <img src="../assets/oval_blue_with_white_interior_mod.png"/>
        <p id="number">707.477.1658</p>
      </div>

    </div>
    <img id="girl" class="mobile-hide" src="../assets/girl_at_piano.jpg"/>
  </div>
</template>

<script>
export default {
  name: "TopSection"
}
</script>

<style scoped>

.container {
  display: flex;
}

p {
  font-size: 32px;
  text-align: left;
  line-height: 1.4em;
}

.cta {
  font-size: 36px;
}

#girl {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  height: 100%;
  width: 40%;
}

#number-container {
  position: relative;
}

#number-container img {
  width: 60%;
  padding: 0;
}

#number {
  font-weight: 900;
  font-size: 3em;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Phones */
@media only screen
and (max-device-width: 667px)
and (orientation: portrait) {

  .container {
    display: inherit;
  }

  p {
    font-size: 28px;
  }

  #number-container {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  #number-container img {
    width: 100%;
  }

  #number {
    font-size: 2.5em;
  }

  .cta {
    margin-bottom: 0;
  }
}

</style>